import { render, staticRenderFns } from "./quizCard.vue?vue&type=template&id=66c3a84e&scoped=true"
import script from "./quizCard.vue?vue&type=script&lang=js"
export * from "./quizCard.vue?vue&type=script&lang=js"
import style0 from "./quizCard.vue?vue&type=style&index=0&id=66c3a84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c3a84e",
  null
  
)

export default component.exports